import React from 'react'
import { getNavSvgAsset } from '../lib/menu/navIconAssets'

export default function NavIcon({ navItemId, className = '', size = 18 }) {
  const svgAsset = getNavSvgAsset(navItemId)
  if (!svgAsset) return null
  return (
    <img
      src={svgAsset}
      alt=""
      className={`inline-flex shrink-0 object-contain ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  )
}
